@use '../../styles/uefa-css/core/mixins' as mixins;

.overlay {
  @include mixins.position(absolute, 0, 0, 0, 0);

  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3;
}
